import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanizeMilliseconds'
})
export class HumanizeMillisecondsPipe implements PipeTransform {

  transform(value: number): string {
    if (value == null || isNaN(value)) {return '';}

    // Calculate hours and minutes
    const hours = Math.floor(value / (60 * 60 * 1000));
    value %= (60 * 60 * 1000);
    const minutes = Math.floor(value / (60 * 1000));

    // Generate the output
    let result = '';
    if (hours > 0) {
      result += `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
      if (minutes > 0) {
        result += ` ${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
      }
    } else {
      result += `${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
    }

    return result;
  }

}
